// src/use-company.ts
import { useAuthContext, useHttp } from "@clara/auth";
import { useAsyncFn, useEffectOnce } from "@clara/hooks";
var flattBilling = (c) => {
  var _a;
  return Object.assign(c, (_a = c.billingStatement) != null ? _a : {});
};
function useCompany(props = { fetchOnMount: true }) {
  const auth = useAuthContext();
  const API_URL = auth.config.url;
  const http = useHttp();
  const [state, read] = useAsyncFn(
    async () => {
      const response = http.get(API_URL + "/company").then(flattBilling);
      return response;
    },
    [http],
    { loading: true }
  );
  useEffectOnce(() => {
    if (props.fetchOnMount)
      read();
  });
  const create = useAsyncFn(async (name) => {
    const response = await http.post(
      API_URL + "/company/additionalCompany",
      {
        companyName: name
      }
    );
    return response;
  });
  const update = useAsyncFn(
    async (data) => {
      const response = await http.put(API_URL + "/company", data).then(read);
      return response;
    },
    [read]
  );
  const download = useAsyncFn(
    async (docId, isOpen = true) => {
      const response = await http.get(API_URL + "/documents/company/downloadUrl", {
        documentIds: docId
      }).then((xs) => {
        if (isOpen)
          xs.forEach((u) => window.open(u));
        return xs;
      });
      return response;
    },
    [API_URL]
  );
  const resource = {
    read: {
      ...state,
      call: read
    },
    update: {
      ...update[0],
      call: update[1]
    },
    create: {
      ...create[0],
      call: create[1]
    },
    download: {
      ...download[0],
      call: download[1]
    }
  };
  return {
    ...resource,
    model: resource.read.value,
    /**
     * @deprecated use `model` or `read.value`
     */
    company: resource.read.value,
    /**
     * @deprecated use `read.call`
     */
    fetchCompany: resource.read.call,
    /**
     * @deprecated use `read.loading`
     */
    loading: resource.read.loading,
    /**
     * @deprecated use `read.error`
     */
    error: resource.read.error,
    /**
     * @deprecated use `read.error`
     */
    rejected: !!resource.read.error,
    /*
     * @deprecated use `read.value` or `model`
     */
    resolved: !!resource.read.value,
    /**
     * @deprecated use `update.call`
     */
    updateCompany: resource.update.call
  };
}

export {
  useCompany
};
